// don't change these, these are set in the backend
// error message when jailed
export const JAILED_ERROR_MESSAGE = "Permission denied";
// error message when not jailed (invalid token, logged out, etc)
export const LOGGED_OUT_ERROR_MESSAGE = "Unauthorized";
